import { language } from '@com/utils/language'
import { mindworksCreative } from '@com/utils/redirect-to-cn'

const enDocHost = `https://doc.${mindworksCreative}/`

export type ProduceType = 'gm' | 'ps' | 'dm'
const urlMap: Record<ProduceType, Record<string, string>> = {
  gm: {
    // gmaker
    en: enDocHost,
    zh: 'https://doc.playturbo.cn/',
  },
  ps: {
    // playsmart（目前只有中文文档）
    en: enDocHost,
    zh: 'https://doc.playturbo.cn/',
  },
  dm: {
    // dmaker
    en: enDocHost,
    zh: 'https://doc.playturbo.cn/',
  },
}

export type DomainType = 'cn' | 'com'
export const routeHelperMap: Record<DomainType, string> = {
  cn: 'https://doc.playturbo.cn/',
  com: enDocHost,
}

export function getRouteHelperUrlByDomain(type: DomainType, url: string) {
  return `${routeHelperMap[type]}${url}`
}

function getUrl(type: ProduceType) {
  const getCurLang = () => {
    const lang = language.get()
    if (lang.indexOf('zh') > -1) {
      return 'zh'
    }
    return 'en'
  }

  return urlMap[type][getCurLang()]
}

export function openHelperPage(type: ProduceType): Window | null {
  const url = getUrl(type)
  return window.open(url, '_blank')
}

// 判断变量是否有值，空对象、空数组、空字符串、null、undefined都算没值
export function hasValue(variable: any): boolean {
  return (
    variable !== null &&
    variable !== undefined &&
    variable !== '' &&
    !(Array.isArray(variable) && variable.length === 0) &&
    !(typeof variable === 'object' && Object.keys(variable).length === 0)
  )
}
